import * as React from 'react';

import PropTypes from 'prop-types';

type Context = Record<string, $TSFixMe>; // TODO: refine context type value

type Props = {
  customContext: Context;
  children: React.ReactElement;
};

/**
 * Sometimes (particularly in conjunction with rendering Backbone Views into
 * React Components), using a factory for context providers like
 * `vendor/cnpm/fluxible.v0-4/addons/provideContext.js` will cause React to "re-mount"
 * a component rather than "update" it as expected. Using the strategy below
 * (just using a component rather than creating them on the fly) allows us to maintain
 * the contract of "updating" existing components.
 */
class ContextProvider extends React.Component<Props> {
  static displayName = ContextProvider;

  static childContextTypes: Context = {};

  constructor(props: Props) {
    super(props);

    const childContextTypes: Context = {};
    Object.keys(props.customContext).forEach((key) => {
      childContextTypes[key] = PropTypes.any;
    });

    // Because we're modifying the component itself (it needs to be defined on the component),
    // we need to aggregate changes to the childContextTypes rather than replace them.
    // This is assumed to be somewhat safe since we don't normally have contextual collisions,
    // but this is definitely not a great solution.
    ContextProvider.childContextTypes = {
      ...ContextProvider.childContextTypes,
      ...childContextTypes,
    };
  }

  getChildContext() {
    return Object.assign({}, this.props.customContext);
  }

  render() {
    return React.cloneElement(this.props.children, this.props);
  }
}

export default ContextProvider;
